import React from 'react';
import { Section } from './ui/Section';
export function About() {
  const stats = [{
    label: 'Років досвіду',
    value: '12+'
  }, {
    label: 'Успішних справ',
    value: '500+'
  }, {
    label: 'Адвокатів',
    value: '8'
  }, {
    label: 'Виграних судів',
    value: '92%'
  }];
  return <Section id="about" background="white" className="border-t border-neutral-100" data-id="element-1">
      <div className="grid md:grid-cols-2 gap-12 lg:gap-24 items-start" data-id="element-2">
        <div data-id="element-3">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black mb-6 md:mb-8 leading-tight" data-id="element-4">
            Ми спеціалізуємося виключно на військовому праві.
          </h2>
          <div className="space-y-4 md:space-y-6 text-base md:text-lg text-neutral-600 font-light leading-relaxed" data-id="element-5">
            <p data-id="element-6">
              З початку повномасштабного вторгнення ми допомогли сотням
              військовослужбовців та військовозобов'язаних захистити свої
              законні права.
            </p>
            <p data-id="element-7">
              Наша місія — забезпечити справедливість та дотримання закону у
              відносинах між громадянами та військовими структурами. Ми
              розуміємо специфіку роботи ТЦК та ВЛК, знаємо всі тонкощі процедур
              та готові боротися за ваші інтереси.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6 md:gap-x-12 md:gap-y-12 mt-12 md:mt-16" data-id="element-8">
            {stats.map((stat, index) => <div key={index} className="flex flex-col border-l border-neutral-200 pl-4 md:pl-6 group hover:border-black transition-colors" data-id="element-9">
                <span className="text-3xl md:text-4xl font-bold text-black mb-2 group-hover:scale-105 transition-transform" data-id="element-10">
                  {stat.value}
                </span>
                <span className="text-xs md:text-sm text-neutral-500 uppercase tracking-wider" data-id="element-11">
                  {stat.label}
                </span>
              </div>)}
          </div>
        </div>

        <div className="relative mt-8 md:mt-0" data-id="element-12">
          {/* Team photo */}
          <div className="aspect-[4/5] w-full bg-neutral-100 relative overflow-hidden border border-neutral-200" data-id="element-13">
            <img src="https://cdn.magicpatterns.com/uploads/hdP4Y1cwAVbDzaY7s8Fw9r/photo_2026-01-24_18-36-15.jpg" alt="Команда адвокатів" className="w-full h-full object-cover" data-id="element-14" />
            {/* Overlay pattern */}
            <div className="absolute inset-0 bg-gradient-to-t from-white/10 to-transparent" data-id="element-15"></div>
          </div>
          <div className="mt-4 flex justify-between items-end border-b border-black pb-2" data-id="element-16">
            <span className="text-sm font-medium text-black" data-id="element-17">
              Професійний захист
            </span>
            <span className="text-xs text-neutral-500" data-id="element-18">Київ, 2024</span>
          </div>

          {/* Decorative element */}
          <div className="absolute -bottom-8 -right-8 w-24 md:w-32 h-24 md:h-32 border border-neutral-200 -z-10 hidden md:block" data-id="element-19"></div>
        </div>
      </div>
    </Section>;
}